import { NixpkgsTracker } from "./NixpkgsTracker";

const App = () => (
  <>
    <NixpkgsTracker />
    <footer class="app-footer">
      <a
        href="https://github.com/ocfox/nixpkgs-tracker/"
        target="_blank"
        rel="noopener noreferrer"
      >
        check source
      </a>
    </footer>
  </>
);

export default App;
